import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { AppRoutingConstants } from "../../../app-routing.constants";
import memo from "memo-decorator";
let SettingLinksWithModulePipe = class SettingLinksWithModulePipe {
    transform(settingLinks, selectedSystemModuleID) {
        settingLinks.forEach(link => {
            link.address = AppRoutingConstants.createRouteToViewWithPrefixRouteSeparator(selectedSystemModuleID, link.address);
        });
        return settingLinks;
    }
};
__decorate([
    memo()
], SettingLinksWithModulePipe.prototype, "transform", null);
SettingLinksWithModulePipe = __decorate([
    Pipe({
        name: "settingLinksWithModule"
    })
], SettingLinksWithModulePipe);
export { SettingLinksWithModulePipe };
